<div class="container">
    <h4 class="fw-bolder">{{'目前學年期：'|translate}}{{model.Years}}{{'學年第'|translate}}{{model.Term}}{{'學期'|translate}}</h4>
    <small class="fw-bolder">*<span class="text-danger">{{'紅字'|translate}}</span>{{'代表已開設，'|translate}}<span class="text-primary fw-bolder">{{'藍字'|translate}}</span>{{'代表未開設；點選進行開設/取消。'|translate}}</small>
    <app-cur-class id="cur-class" [curList]="data" [functionType]="functionType" (childEvent)="resfresh()"></app-cur-class>
    <app-cur-class-rwd id="cur-class-rwd" [curList]="data" [functionType]="functionType" (childEvent)="resfresh()"></app-cur-class-rwd>
</div>
